import tw, { styled } from 'twin.macro';

const PreviewCondition = styled.span`
  ${tw`text-core-primary ml-1 lowercase`}
`;

export default PreviewCondition;
